import PhotoVerificationItemCard from '../PhotoVerificationItemCard';
import { sortByStatus } from '@/lib/utils.ts';
import { TProps } from '.';

const UserPhotoGridPictures = ({
	onClickDeletePictureBtn,
	onClickAcceptDenyBtn,
	cardClassName,
	userData,
	withButtons = true,
	readonly = false
}: Omit<TProps, 'className'>) => {

	if (!userData?.pictures || userData.pictures.length === 0) {
		return (
			<p className='flex flex-col space-y-2 text-center md:ms-10 my-auto'>
				<span className='font-semibold'>
					Aucune photo
				</span>
				<span className='text-sm text-muted-foreground'>
					Ses photos ont été supprimées car non conformes.
				</span>
			</p>
		);
	}

	return (
		<>
			{
				userData
					.pictures
					.sort(sortByStatus)
					.map(
						(picture, index) => (
							<PhotoVerificationItemCard
								key={`${picture.position}.${index}`}
								picture={picture}
								readonly={readonly}
								userId={userData._id}
								withButtons={withButtons}
								className={cardClassName}
								onClickAcceptDenyBtn={onClickAcceptDenyBtn}
								onClickDeletePictureBtn={onClickDeletePictureBtn} />
						)
					)
			}
		</>
	);

};

export default UserPhotoGridPictures;
